import { render, staticRenderFns } from "./SavedArticle.vue?vue&type=template&id=505c1dda&"
import script from "./SavedArticle.vue?vue&type=script&lang=js&"
export * from "./SavedArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports